'use client'

import Image from 'next/image'
import { useRouter, useSearchParams } from 'next/navigation'

import { useTranslations } from 'next-intl'

import { useAppForm } from '@/components/form'

import {
  LoginSchema,
  loginSchema
} from '@/app/(Auth)/login/_login/form-options'
import { useLoginMutation } from '@/query/auth'

export default function LoginPage() {
  const t = useTranslations('auth.login')
  const tValidation = useTranslations('auth.login.validation')
  const router = useRouter()
  const searchParams = useSearchParams()
  const { isPending, mutate } = useLoginMutation()
  const form = useAppForm({
    defaultValues: {
      identity: '',
      password: ''
    } as LoginSchema,
    onSubmit: async ({ value }) => {
      const redirectPath = searchParams.get('redirect')
      mutate(value, {
        onSuccess: () => {
          // Redirect to the saved path or to home
          router.push(redirectPath || '/')
        }
      })
    },
    validators: {
      onChange: loginSchema({ t: tValidation })
    }
  })

  return (
    <form
      className="block w-full space-y-5"
      onSubmit={(e) => {
        e.preventDefault()
        form.handleSubmit()
      }}
    >
      <div className="flex flex-col gap-0 pb-3">
        <h1 className="text-card-foreground text-xl font-extrabold">
          {t('title')}
        </h1>
        <span className="text-muted-foreground text-sm font-medium">
          {t('subtitle')}
        </span>
      </div>

      <div className="relative flex h-[140px]">
        <div className="h-[90px] w-[368px] rounded-xl bg-gradient-to-r from-gray-500/20 via-transparent to-gray-500/20 backdrop-blur-[30px]"></div>

        <Image
          alt={t('avatarAlt')}
          className="absolute start-1/2 bottom-0 size-[100px] -translate-x-1/2 transform rounded-full border-[5px] border-white object-cover rtl:translate-x-1/2"
          height={100}
          src="/media/person.png"
          width={100}
        />
      </div>

      <form.AppField name="identity">
        {(field) => (
          <field.Input
            autoComplete="email"
            placeholder={t('emailPlaceholder')}
          />
        )}
      </form.AppField>

      <form.AppField name="password">
        {(field) => (
          <div className="flex flex-col gap-2">
            <field.Password
              autoComplete="current-password"
              forgotPassword
              placeholder={t('passwordPlaceholder')}
            />
          </div>
        )}
      </form.AppField>

      <div className="flex flex-col gap-2.5">
        <form.AppForm>
          <form.SubmitButton isLoading={isPending}>
            {t('submitButton')}
          </form.SubmitButton>
        </form.AppForm>
      </div>
    </form>
  )
}
